import { render, staticRenderFns } from "./adddyx.vue?vue&type=template&id=cb20bfe4"
import script from "./adddyx.vue?vue&type=script&lang=js"
export * from "./adddyx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb20bfe4')) {
      api.createRecord('cb20bfe4', component.options)
    } else {
      api.reload('cb20bfe4', component.options)
    }
    module.hot.accept("./adddyx.vue?vue&type=template&id=cb20bfe4", function () {
      api.rerender('cb20bfe4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/dyxmanager/dyxDisGroup/adddyx.vue"
export default component.exports